import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnCard as CnCardView } from './cn-card';
export const CnCard = withI18n(CnCardView, { locale, _noHoc: true });
export * from './types';
